import React, { PureComponent } from 'react';
import { bool, func } from 'prop-types';
import styled, { css } from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Button, { ButtonVariations } from '../SolvPatternLibrary/Button';
import { analyticsTrackEvent } from '../../core/analytics';
import { colors } from '../../constants/colors';
import { fontFamily, fontSize } from '../../constants/text';
import { biggerThan, smallerThanOrEqualTo } from '../../core/util/styledComponents';
import { WAIT_LIST_DELAYS_MODAL_CLOSE } from '../../core/analytics/events';

export const DELAYS_MODAL = 'delays modal';

const SmoothDialog = styled(Dialog)`
  -webkit-font-smoothing: antialiased;
  & .dialog-root {
    margin: 25px;
  }
`;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${biggerThan.sm`
    padding: 30px 50px;
  `}
  ${smallerThanOrEqualTo.sm`
    padding: 30px 25px;
  `}
`;

const ButtonContainer = styled.div``;

const Title = styled.h3`
  margin: 10px 0;
`;

const Disclaimer = styled.p`
  color: ${colors.mrGray};
`;

const CTA = styled(Button)`
  margin-top: 20px;
`;

const Illustration = styled.img`
  width: 100%;
`;

type Props = {
  // @ts-expect-error ts-migrate(2749) FIXME: 'bool' refers to a value, but is being used as a t... Remove this comment to see the full error message
  fullScreen?: bool;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  onClose?: func;
  // @ts-expect-error ts-migrate(2749) FIXME: 'bool' refers to a value, but is being used as a t... Remove this comment to see the full error message
  open?: bool;
};

class Modal extends PureComponent<Props> {
  handleClose = () => {
    analyticsTrackEvent(WAIT_LIST_DELAYS_MODAL_CLOSE);
    this.props.onClose();
  };

  render() {
    const { open } = this.props;

    return (
      <SmoothDialog
        onClose={this.handleClose}
        open={open}
        PaperProps={{ classes: { root: 'dialog-root' } }}
      >
        <Root>
          <Illustration src="/images/waitList/delay_modal.png" />

          <Title>Delays and wait times</Title>

          <Disclaimer>
            We're working to see patients safely and quickly, but visit times can vary depending on
            a patient's condition.
            <br />
            <br />A sudden increase in very ill patients might result in longer waits. We'll do our
            best to keep you updated if we experience any delays.
          </Disclaimer>

          <ButtonContainer>
            <CTA onClick={this.handleClose}>Got it!</CTA>
          </ButtonContainer>
        </Root>
      </SmoothDialog>
    );
  }
}

export default withMobileDialog({ breakpoint: 'xs' })(Modal);
